export default __webpack_public_path__ + "static/media/lionshare.1f053494.png";